import axios from "axios"
import { config } from './apiUrl';

export  const searchApi = (data) =>{
  return axios.get(`${config.pageSearch}?key=${data}&lang=en`)}